<template>
    <rkm-area title="Alergias / Reações adversas">
        <template
            v-if="!readonly"
            slot="trailing"
        >
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                id="alergias"
                title="Adicionar alergia"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List
            :data="data"
            :hide-info="hideInfo"
            :readonly="readonly"
        />

        <Modal :data="data" ref="Modal" />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
        hideInfo: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
    },
}
</script>